import { render, staticRenderFns } from "./effectArrivalClueCleaning.vue?vue&type=template&id=06c17a0b"
import script from "./effectArrivalClueCleaning.vue?vue&type=script&lang=js"
export * from "./effectArrivalClueCleaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports